import thunk from 'redux-thunk';
import { persistState } from './persist-state';
import { RootReducer } from '../reducer';
import { ULYTICS_MIDDLEWARE } from '@updater/ulytics';
import { ENVIRONMENT, ENVIRONMENTS, IS_TEST } from '../../environment';
import { EPICS_SERVICE } from '../epics';
import { MESSAGE_MIDDLEWARE } from '../message';

const INITIAL_STATE = {};
const CURRENT_ENV = ENVIRONMENT.name;
const DEBUG_BLACKLIST = [ENVIRONMENTS.PRODUCTION, ENVIRONMENTS.TEST];

const logger = store => next => action => {
  const prevState = store.getState();
  next(action);
  const nextState = store.getState();
  try {
    if (ENVIRONMENT?.debug?.moverAppRedux) {
      /* eslint-disable no-console */
      console.log(`%c[ACTION] - ${action.type} -`, 'color: #0091EA', {
        action,
        prevState,
        nextState,
      });
      /* eslint-enable */
    }
  } catch (e) {} // eslint-disable-line no-empty
};

const REDUX_DEVTOOLS_EXTENSION =
  !IS_TEST &&
  typeof window !== 'undefined' &&
  window.__REDUX_DEVTOOLS_EXTENSION__ &&
  window.__REDUX_DEVTOOLS_EXTENSION__();

export function ConfigureStore($ngReduxProvider) {
  'ngInject';

  let isHalted = false;

  const haltMiddleware = () => next => action => {
    if (action.type === 'HALT') {
      isHalted = true;
      try {
        /* eslint-disable no-console */
        console.log(`%c[ACTION] - HALT`, 'color: #0091EA');
        /* eslint-enable */
      } catch (e) {} // eslint-disable-line no-empty
    }
    if (!isHalted) next(action);
  };

  let middleware = [
    thunk,
    'ngUiRouterMiddleware',
    'ng1RequestMiddleware',
    MESSAGE_MIDDLEWARE,
    haltMiddleware,
  ];

  // Setup persistent storage via localstorage
  const enhancers = [persistState];

  if (REDUX_DEVTOOLS_EXTENSION) {
    enhancers.push(REDUX_DEVTOOLS_EXTENSION);
  }

  // Don't log actions when in a blacklisted environment.
  if (!DEBUG_BLACKLIST.includes(CURRENT_ENV)) {
    middleware.push(logger);
  }

  // Don't include analytics when in test env or we
  // could possibly unintentionally spam our analytics
  // services
  if (ENVIRONMENTS.TEST !== CURRENT_ENV) {
    middleware.push(ULYTICS_MIDDLEWARE);
  }

  // Add epics after middleware
  middleware.push(EPICS_SERVICE);

  $ngReduxProvider.createStoreWith(
    RootReducer,
    middleware,
    enhancers,
    INITIAL_STATE
  );
}
